import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));


function renderApp() {
  root.render(
    <React.Fragment>
      <App />
    </React.Fragment>
  );
}

fetch('/theme-config.json')
  .then(res => res.json())
  .then(config => {
    console.debug('Theme loaded successfully');
    const doc = document.documentElement;
    Object.entries(config).forEach(([key, value]) => {
      doc.style.setProperty(`--${key}`, value);
    });
    renderApp();
  })
  .catch(()=>{
    console.debug('Failed to load theme, using default theme');
    renderApp();
  })
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
